import React from "react";

const parseAndFormatText = (text) => {
  const elements = [];
  const lines = text.split("\n");

  let unorderedListItems = [];
  let orderedListItems = [];

  lines.forEach((line, index) => {
    if (!line.trim()) return; // Skip empty lines

    // Handle formatting replacements
    line = line.replace(/\*\*\*(.*?)\*\*\*/g, "<em><strong>$1</strong></em>"); // Bold + Italic
    line = line.replace(/\*\*(.*?)\*\*/g, "$1"); // ** Remove unwanted bold
    line = line.replace(/\*(.*?)\*/g, "<em>$1</em>"); // Italic
    line = line.replace(/__(.*?)__/g, "<u>$1</u>"); // Underline
    line = line.replace(/~~(.*?)~~/g, "<del>$1</del>"); // Strikethrough
    line = line.replace(/`(.*?)`/g, "<code class='summary-text'>$1</code>"); // Inline Code

    // Handle Email Links
    line = line.replace(/([\w\.-]+@[\w\.-]+\.\w+)/g, '<a href="mailto:$1">$1</a>');

    // Handle Hyperlinks [text](url)
    line = line.replace(/\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g, '<a href="$2" target="_blank">$1</a>');

    // ** Dynamically Bold Only Attribute Labels **
    line = line.replace(/^([\w\s/]+?):\s/, "<strong>$1:</strong> "); // Only bold labels at the start

    // Handle Blockquotes "> Text"
    if (line.startsWith("> ")) {
      elements.push(
        <blockquote key={index} className="summary-text">
          {line.substring(2)}
        </blockquote>
      );
      return;
    }

    // Handle Code Blocks """ code """
    if (line.startsWith("'''") || line.startsWith('"""')) {
      elements.push(
        <pre key={index} className="summary-text">
          <code>{line.replace(/['"`]/g, "")}</code>
        </pre>
      );
      return;
    }

    // Handle Numbered Lists (1. Item)
    if (/^\d+\./.test(line)) {
      orderedListItems.push(line.substring(3));
      return;
    } else if (orderedListItems.length) {
      elements.push(
        <ol key={`ol-${index}`}>
          {orderedListItems.map((item, idx) => (
            <li key={idx} className="summary-text">
              {item}
            </li>
          ))}
        </ol>
      );
      orderedListItems = [];
    }

    // Handle Unordered Lists "- Item" or "* Item"
    if (line.startsWith("- ") || line.startsWith("* ")) {
      unorderedListItems.push(line.substring(2));
      return;
    } else if (unorderedListItems.length) {
      elements.push(
        <ul key={`ul-${index}`}>
          {unorderedListItems.map((item, idx) => (
            <li key={idx} className="summary-text">
              {item}
            </li>
          ))}
        </ul>
      );
      unorderedListItems = [];
    }

    elements.push(
      <p key={index} className="summary-text" dangerouslySetInnerHTML={{ __html: line }} />
    );
  });

  // Close any remaining lists
  if (unorderedListItems.length) {
    elements.push(
      <ul key="last-ul">
        {unorderedListItems.map((item, idx) => (
          <li key={idx} className="summary-text">
            {item}
          </li>
        ))}
      </ul>
    );
  }
  if (orderedListItems.length) {
    elements.push(
      <ol key="last-ol">
        {orderedListItems.map((item, idx) => (
          <li key={idx} className="summary-text">
            {item}
          </li>
        ))}
      </ol>
    );
  }

  return elements;
};

const SummaryView = ({ summaryData }) => {
  return <div>{parseAndFormatText(summaryData?.text)}</div>;
};

export default SummaryView;
